import React from 'react';
import {
  FormControlLabel,
  Checkbox,
  FormGroup,
  Typography,
} from '@material-ui/core';
import styled from '@emotion/styled';
import { ROLES } from './constants/contants';

const PermissoesUsuario = ({
  permissoesSelecionadas,
  setPermissoesSelecionadas,
  disabled,
}) => {
  const handleToggle = (role) => {
    setPermissoesSelecionadas((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );
  };

  return (
    <Container>
      <SectionTitle>Permissões do Usuário</SectionTitle>
      <CheckboxGrid>
        {ROLES.map((role) => (
          <FormControlLabel
            key={role.value}
            control={
              <Checkbox
                checked={permissoesSelecionadas.includes(role.value)}
                onChange={() => handleToggle(role.value)}
                color="primary"
                disabled={disabled}
              />
            }
            label={<Label>{role.label}</Label>}
          />
        ))}
      </CheckboxGrid>
    </Container>
  );
};

export default PermissoesUsuario;

const Container = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
  padding: 18px;
`;

const SectionTitle = styled(Typography)`
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #333;
  margin-bottom: 16px !important;
`;

const CheckboxGrid = styled(FormGroup)`
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px 16px;
`;

const Label = styled.span`
  font-size: 14px;
  color: #555;
`;
